import React from "react";

const ToolboxContext = React.createContext({});

export default ToolboxContext;
